'use client'

import { Button } from '@vinted/web-ui'

import { useTracking } from '@marketplace-web/shared/event-tracker'
import { getFingerprint } from '@marketplace-web/domain/audit'
import {
  NewAgainIntroductionSectionModel,
  NewAgainLandingPageEvent,
  landingPageEvent,
} from '@marketplace-web/domain/marketing-landing-page-data'
import { ClickableElement } from 'constants/tracking/clickable-elements'

type Props = {
  data: NewAgainIntroductionSectionModel
}

export const NewAgainIntroduction = ({
  data: { title, description, ctaText, ctaLink, videoUrl },
}: Props) => {
  const { track } = useTracking()
  const handleOnCtaClick = async () =>
    track(
      landingPageEvent({
        event: NewAgainLandingPageEvent.CtaClick,
        target: ClickableElement.CtaRedirect,
        targetDetails: ctaLink,
        deviceId: await getFingerprint(),
      }),
    )

  return (
    <section className="new-again_introduction-section" data-testid="introduction-section">
      <h1 className="new-again__introduction-title">{title}</h1>
      <div className="new-again__introduction-content">
        <iframe
          src={videoUrl}
          title={title}
          className="new-again__introduction-video-iframe"
          allow="clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          data-testid="new-again-intro_video"
        />

        <p className="new-again__introduction-description">{description}</p>
        <div className="new-again__introduction-cta">
          <Button
            styling={Button.Styling.Filled}
            text={ctaText}
            url={ctaLink}
            onClick={handleOnCtaClick}
            testId="new-again__introduction-cta"
          />
        </div>
      </div>
    </section>
  )
}
